import { render, staticRenderFns } from "./BusinessUnit.vue?vue&type=template&id=f5a76b8c&"
import script from "./BusinessUnit.vue?vue&type=script&lang=js&"
export * from "./BusinessUnit.vue?vue&type=script&lang=js&"
import style0 from "./BusinessUnit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports